import React from 'react';

const IconKeluar = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0376 5C8.14643 5 5 8.13843 5 12C5 15.8616 8.14643 19 12.0376 19C14.6436 19 16.9181 17.592 18.1354 15.4975C18.4129 15.02 19.025 14.8579 19.5025 15.1354C19.98 15.4129 20.1421 16.025 19.8646 16.5025C18.3024 19.1904 15.3818 21 12.0376 21C7.05072 21 3 16.975 3 12C3 7.02502 7.05072 3 12.0376 3C15.2597 3 18.0887 4.68 19.688 7.20645C19.9834 7.6731 19.8445 8.29086 19.3779 8.58625C18.9112 8.88165 18.2935 8.74282 17.9981 8.27617C16.7516 6.30697 14.5486 5 12.0376 5Z"
        fill="#CC1C15"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2929 8.29289C12.6834 7.90237 13.3166 7.90237 13.7071 8.29289L16.7071 11.2929C17.0766 11.6624 17.0993 12.2541 16.7593 12.6508L13.7593 16.1508C13.3998 16.5701 12.7685 16.6187 12.3492 16.2593C11.9299 15.8998 11.8813 15.2685 12.2407 14.8492L13.8258 13L9 13C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11L13.5858 11L12.2929 9.70711C11.9024 9.31658 11.9024 8.68342 12.2929 8.29289Z"
        fill="#CC1C15"
      />
    </svg>
  );
};

export default IconKeluar;
